<template>
  <rubric-fullscreen-modal
    mode="create"
    hide-footer
    :header-title="$t('rubrics.createRubric')"
    @back="$emit('back')"
  >
    <div class="loading-content">
      <h1 class="loading-title heading-m">
        ✨ {{ $t("rubrics.buildingRubric") }}
      </h1>
      <div class="loading-progress">
        <InfinityLoading />
        <p class="loading-text paragraph-s">
          {{ $t("rubrics.almostDone") }}
        </p>
      </div>
      <div class="tips-container">
        <eg-icon
          icon="bulb-light"
          color="var(--color-icon-primary-primary)"
          size="medium"
        />
        <div class="tips-content">
          <h4>{{ $t("rubrics.tips") }}</h4>
          <ul class="button-l">
            <li>{{ $t("rubrics.tip1") }}</li>
            <li>{{ $t("rubrics.tip2") }}</li>
            <li>{{ $t("rubrics.tip3") }}</li>
          </ul>
        </div>
      </div>
    </div>
  </rubric-fullscreen-modal>
</template>

<script>
import InfinityLoading from "@/components/rubrics/newRubric/components/infinity-loading.vue";
import RubricFullscreenModal from "@/components/rubrics/components/rubric_fullscreen_modal.vue";

export default {
  name: "RubricAiLoadingFullscreen",
  components: {
    InfinityLoading,
    RubricFullscreenModal,
  },
  emits: ["back"],
};
</script>

<style scoped lang="scss">
.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 85vw;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  min-height: calc(100vh - 148px - var(--maintenance-height));
}
::v-deep .rubric-tab-content {
  min-height: calc(100vh - 68px - var(--maintenance-height));
}

.loading-title {
  font-weight: var(--typography-font-weight-fw-600);
  margin-bottom: 2.25rem;
  color: var(--color-text-neutral-on-white);
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
}

.loading-progress {
  margin-bottom: 4rem;
}

.loading-text {
  margin-top: 1.5rem;
  font-size: var(--typography-font-size-fs-300);
  line-height: 1.5;
}

.tips-container {
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  text-align: left;
  margin: 0 auto;
  border-radius: var(--radius-rd-400, 12px);
  background: var(--color-surface-primary-light-1, #f6f2ff);

  @media (max-width: 768px) {
    padding: 1.5rem;
    gap: 1rem;
  }
}

.tips-icon {
  font-size: 2rem;
  flex-shrink: 0;
  line-height: 1;
}

.tips-content {
  flex: 1;

  h4 {
    padding-left: 0.175rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    font-size: 1.125rem;
  }

  ul {
    margin: 0;
    padding-left: 1rem;
    line-height: 170%;
    font-size: var(--typography-font-size-fs-300);

    li {
      margin-bottom: 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
